exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumb-header .breadcrumbs {\n    padding-bottom: 0px;\n    margin-bottom: 0px;\n}\n\n.breadcrumb {\n    background-color: #fff;\n}\n\n.breadcrumb-item {\n    font-family: Roboto;\n    font-size: 12px;\n    font-weight: normal;\n}\n\n.breadcrumb-item.active {\n    color: Grey 600;\n    font-family: Roboto;\n    font-size: 12px;\n    background: none;\n}\n\n.breadcrumb-item a {\n    color: #319699;\n    font-weight: bold;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n    content: \">\";\n }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/breadcrumbs/styles.css
// module id = 2028
// module chunks = 29